var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 90,
    viewBox: "0 0 121 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1954",
    "data-name": "Group 1954",
    transform: "translate(-359 -362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1792",
    "data-name": "Group 1792",
    transform: "translate(-11472 -8484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_147865",
    "data-name": "Rectangle 147865",
    transform: "translate(11831 8868)",
    fill: "none",
    stroke: "#c2c4c6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 68,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 40,
    height: 67,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_147867",
    "data-name": "Rectangle 147867",
    transform: "translate(11871 8868)",
    fill: "none",
    stroke: "#c2c4c6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 68,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 40,
    height: 67,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_147869",
    "data-name": "Rectangle 147869",
    transform: "translate(11911 8868)",
    fill: "none",
    stroke: "#c2c4c6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 68,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 40,
    height: 67,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_867",
    "data-name": "Line 867",
    x2: 39.641,
    transform: "translate(11831.436 8912.612)",
    fill: "none",
    stroke: "#c2c4c6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_874",
    "data-name": "Line 874",
    x2: 39.641,
    transform: "translate(11871.479 8912.612)",
    fill: "none",
    stroke: "#c2c4c6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_876",
    "data-name": "Line 876",
    x2: 39.641,
    transform: "translate(11911.521 8912.612)",
    fill: "none",
    stroke: "#c2c4c6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_871",
    "data-name": "Line 871",
    x2: 39.641,
    transform: "translate(11831.436 8889.872)",
    fill: "none",
    stroke: "#c2c4c6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_875",
    "data-name": "Line 875",
    x2: 39.641,
    transform: "translate(11871.479 8889.872)",
    fill: "none",
    stroke: "#c2c4c6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_877",
    "data-name": "Line 877",
    x2: 39.641,
    transform: "translate(11911.521 8889.872)",
    fill: "none",
    stroke: "#c2c4c6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3261",
    "data-name": "Path 3261",
    d: "M120,0",
    transform: "translate(11751.076 8889.872)",
    fill: "none",
    stroke: "#c2c4c6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3262",
    "data-name": "Path 3262",
    d: "M120,0",
    transform: "translate(11791.119 8889.872)",
    fill: "none",
    stroke: "#c2c4c6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3263",
    "data-name": "Path 3263",
    d: "M120,0",
    transform: "translate(11831.163 8889.872)",
    fill: "none",
    stroke: "#c2c4c6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147866",
    "data-name": "Rectangle 147866",
    width: 41,
    height: 23,
    transform: "translate(11831 8846)",
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147868",
    "data-name": "Rectangle 147868",
    width: 41,
    height: 23,
    transform: "translate(11871 8846)",
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147870",
    "data-name": "Rectangle 147870",
    width: 41,
    height: 23,
    transform: "translate(11911 8846)",
    fill: "#575757"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.441540dd9c488fdb890cb0db76b9799a.svg";
export { ForwardRef as ReactComponent };